/**
 * @desc 获取物流商收款信息
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsProviderPaymentResponseDto>>;
export function request(providerCode: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsProvider/getProviderPayment/${providerCode}`, {
      method: "POST",

      ...options,
    }),
  );
}
